import { render } from "./print-sales-receipt.vue?vue&type=template&id=b8174dd6&scoped=true"
import script from "./print-sales-receipt.vue?vue&type=script&lang=js"
export * from "./print-sales-receipt.vue?vue&type=script&lang=js"

import "./print-sales-receipt.vue?vue&type=style&index=0&id=b8174dd6&scoped=true&lang=css"

import exportComponent from "/home/runner/work/inventflux-frontend/inventflux-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b8174dd6"]])

export default __exports__